module.exports = __webpack_public_path__ + "assets/img/title-bd8da37e.png";